export default {
  'Custom': 'Aangepaste',
  'Original': 'Origineel',
}